import { AuthService } from './../../../features/auth/auth.service';
import { Component, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ToasterService } from '../../../core/services/toaster.service';
import { SharedService } from '../../../core/services/shared.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CoreModule } from "../../../core/core.module";

@Component({
  selector: 'app-dynamic-popup',
  standalone: true,
  imports: [CommonModule, CoreModule],
  templateUrl: './dynamic-popup.component.html',
  styleUrls: ['./dynamic-popup.component.scss']
})
export class DynamicPopupComponent {
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() actionButtonLabel: string = '';
  @Input() objectId: string = ''
  @Input() slaItemId: string = ''
  @Input() isVisible: boolean = false;
  @Input() Parent: string = '';

  loading: boolean = false;

  // @Output() action: EventEmitter<void> = new EventEmitter<void>();
  @Output() confirm: EventEmitter<void> = new EventEmitter<void>();
  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();
  @Output() onSuccessRefresh: EventEmitter<void> = new EventEmitter<void>();

  constructor(private authService: AuthService, private router: Router, private sharedService: SharedService, private toastr: ToasterService, private cdr: ChangeDetectorRef) { }

  deleteObject(id?: string, slaItemId?: string): void {
    if (!id) return;
    this.cancelAction();
    this.loading = true;

    if (this.Parent === 'sla' && slaItemId) {
      this.sharedService.deleteConfig(id, slaItemId).subscribe({
        next: () => {
          this.handleDeleteSuccess(id);
        },
        error: (error) => {
          this.handleDeleteError(error);
        }
      });
    } else {
      this.sharedService.deleteEntity(this.Parent, id).subscribe({
        next: () => {
          this.loading = false;
          if (this.Parent == "entity") {
            this.toastr.onSuccess("Success", `The ${this.Parent} and all its related information have been deleted successfully`)
          }
          else { this.toastr.onSuccess("Success", `${this.Parent} deleted successfully`) }
          this.onSuccessRefresh.emit();
          this.cdr.detectChanges();
        },
        error: (error) => {
          this.loading = false;
          console.error(`Error deleting ${this.Parent}:`, error);
          this.toastr.onFailure("Error", `Failed to delete ${this.Parent}`);
        }
      });
    }
  }
  private handleDeleteSuccess(id: string): void {
    this.loading = false;
    if (this.Parent === "entity") {
      this.toastr.onSuccess("Success", `The ${this.Parent} and all its related information have been deleted successfully`);
    } else {
      this.toastr.onSuccess("Success", `${this.Parent} deleted successfully`);
    }
    this.onSuccessRefresh.emit();
    this.cdr.detectChanges();
  }

  private handleDeleteError(error: any): void {
    this.loading = false;
    console.error(`Error deleting ${this.Parent}:`, error);
    this.toastr.onFailure("Error", `Failed to delete ${this.Parent}`);
  }
  objectactivation(id: string, status: boolean, slaItemId: string): void {
    this.cancelAction();
    const statusmessage = status ? 'activated' : 'deactivated';
    this.loading = true;


    if (this.Parent === 'sla' && this.slaItemId) {
      this.sharedService.objectactivationForSla(id, slaItemId).subscribe({
        next: () => {
          this.loading = false;
          this.toastr.onSuccess("Success", `The SLA Config and all its related information have been Changed successfully`)
          this.onSuccessRefresh.emit();
          this.cdr.detectChanges();

        },
        error: (error) => {
          this.loading = false;
          console.error(`Error Changing Status:`, error);

        }
      });
    } else {
      this.sharedService.objectactivation(this.Parent, id, status).subscribe({
        next: () => {
          this.loading = false;
          if (this.Parent == "entity") {
            this.toastr.onSuccess("Success", `The ${this.Parent} and all its related information have been ${statusmessage} successfully`)
          }
          else { this.toastr.onSuccess("Success", `the ${this.Parent} has been ${statusmessage} successfully`) }
          this.onSuccessRefresh.emit();
          this.cdr.detectChanges();
        },
        error: (error) => {
          this.loading = false;
          console.error(`Error Changing Status ${this.Parent}:`, error);
        }

      });
    }
  }



  performAction(): void {
    if (!this.objectId && this.actionButtonLabel !== 'logout') {
      this.confirm.emit();
      return;
    }

    switch (this.actionButtonLabel) {
      case 'Delete':
        this.deleteObject(this.objectId, this.slaItemId);

        break;
      case 'Activate':
        this.objectactivation(this.objectId, true, this.slaItemId);
        break;
      case 'Deactivate':
        this.objectactivation(this.objectId, false, this.slaItemId);
        break;
      case 'Edit Parent Entity':
        this.router.navigateByUrl(`/dashboard/edit-entity/${this.objectId}`);
        break;
      case 'Uncheck Is Parent':
        this.confirm.emit();
        break;
      case 'logout':
        this.cancelAction();
        this.authService.logout();
        this.toastr.onSuccess('Success', 'You successfully logged out');
        break;
      case 'Delete Child':
        this.confirm.emit();
        break;
      default:
        console.warn('No action defined for the button');
    }
  }

  // Method to emit the cancel event
  cancelAction(): void {
    this.cancel.emit();
  }
}
